import { useSwipeBack } from "@/hooks/useSwipeBack";

/**
 * Side-effect-only component that mounts the edge-swipe-back gesture.
 * Lives inside <Router> so it can use router hooks.
 */
export function SwipeBackProvider() {
  useSwipeBack(true);
  return null;
}

export default SwipeBackProvider;
